import { seriesColumnList } from '../constants';
import type { HealthSystemSummaryGridRow } from '../interfaces/Dashboard';
import { formatExportTimestamp } from './dateRange';

const escapeCsvValue = (value: unknown): string =>
  `"${String(value ?? '').replace(/"/g, '\\"')}"`;

/** Triggers a client-side download of `content` as `filename`. */
const downloadBlob = (content: string, filename: string, type: string) => {
  const blob = new Blob([content], { type });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/**
 * Exports the health-system summary grid: Name, one column per status series,
 * then Total Requests — the same column order the on-screen table uses.
 */
export const exportSummaryToCSV = (
  rows: HealthSystemSummaryGridRow[],
  filterType: string,
): void => {
  const headers = [
    'Name',
    ...seriesColumnList.map((column) => column.field),
    'Total Requests',
  ];

  const keyForHeader = (header: string) => {
    if (header === 'Name') return 'healthSystemName';
    if (header === 'Total Requests') return 'totalRequests';
    return header;
  };

  const csvRows = [
    headers.join(','),
    ...rows.map((row) =>
      headers
        .map((header) => escapeCsvValue(row[keyForHeader(header)]))
        .join(','),
    ),
  ];

  downloadBlob(
    csvRows.join('\n'),
    `${filterType} Summary${formatExportTimestamp()}.csv`,
    'text/csv',
  );
};
